import { defineRule } from '../define-rule'
import { assertTypes, toNumber } from '@/libs/utils'
import type { BaseRuleConstructorParams } from '../ts/rule-constructor-parameter.type'

export type MaxRuleConstructorParams = BaseRuleConstructorParams<{ max: number }>

export const max = defineRule('max', ({ config, errorMessage }: MaxRuleConstructorParams) => {
  const { max } = config
  return (value: string | number) => {
    assertTypes(value, 'string', 'number')
    return toNumber(value as string | number) <= max || (errorMessage ?? false)
  }
})
